import requestV2 from '@/service/request-v2'
import { normalizePageResult } from '@/service/adapters/page-result'
import type { PageQuery, PageResult } from '@/types/crud'

export interface LiveRetainedFilters {
  channelId: string | number
  timeSlot: string[]
}

export interface LiveRetainedRecord {
  id: string | number
  channelName: string
  timeLong: string | number
  timeSlot: string
  statisticsNum: number
  totalNum: number
  retainedRate: string | number
}

export interface LiveRetainedForm {
  channelId: string | number
  timeLong: string | number
  timeSlot: Date[]
}

export interface LiveRetainedChannel {
  rowId: string | number
  eventName: string
}

function buildParams(query: PageQuery<LiveRetainedFilters>) {
  return {
    ...query.filters,
    pageNo: query.pageNo,
    pageSize: query.pageSize,
    ...(query.sort
      ? { orderBy: query.sort.prop, orderType: query.sort.order }
      : {})
  }
}

async function requireExportFile(blob: Blob) {
  if (!blob.type.includes('application/json')) return blob
  const payload = JSON.parse(await blob.text()) as { message?: string }
  throw new Error(payload.message || '下载失败')
}

export async function fetchLiveRetainedStatisticsPage(
  query: PageQuery<LiveRetainedFilters>,
  signal: AbortSignal
): Promise<PageResult<LiveRetainedRecord>> {
  const payload = await requestV2.get<unknown>({
    url: '/main/liveRetainedStatistics/queryByCondition',
    params: buildParams(query),
    signal
  })
  return normalizePageResult<LiveRetainedRecord>(payload)
}

export async function fetchLiveRetainedChannelOptions() {
  const payload = await requestV2.get<unknown>({
    url: '/main/customerEvents/queryByCondition',
    params: { pageNo: 1, pageSize: 1000 }
  })
  return normalizePageResult<LiveRetainedChannel>(payload).records
}

export function createLiveRetainedStatistics(payload: LiveRetainedForm) {
  return requestV2.post<void>({
    url: '/main/liveRetainedStatistics/add',
    data: payload
  })
}

export function deleteLiveRetainedStatistics(id: LiveRetainedRecord['id']) {
  return requestV2.delete<void>({ url: `/main/liveRetainedStatistics/${id}` })
}

export function exportLiveRetainedStatistics(
  query: PageQuery<LiveRetainedFilters>
) {
  return requestV2
    .get<Blob>({
      url: '/main/liveRetainedStatistics/download',
      params: buildParams(query),
      responseType: 'blob'
    })
    .then(requireExportFile)
}
